import React, { useState, useContext, useEffect } from 'react';
import Helmet from 'components/Helmet';
import Context from 'container';

export default function (props) {
  const { dispatch } = useContext(Context);
  const [iframeHeight, setIframeHeight] = useState(500); // 初始高度
  const path = props.location.pathname
  const isLandingPage = path.replace(/[^a-zA-Z]/g, '') === 'ai'

  useEffect(() => {
    if (isLandingPage) {
      dispatch({ theme: 'dark' })
    } else {
      dispatch({ theme: undefined })
    }
  }, [isLandingPage])

  const handleIframeLoad = (event) => {
    try {
      const iframeBody = event.target.contentDocument.body;
      const height = iframeBody.scrollHeight;
      setIframeHeight(height);
    } catch (error) {
      console.error('无法获取 iframe 内容高度:', error);
    }
  };

  return (
    <React.Fragment>
      <Helmet title="AI-端点-Terminus-全链路解决方案" />
      <iframe
        src={isLandingPage ? "/ai/ai-native-erp.html" : `${path}.html`}
        onLoad={handleIframeLoad}
        style={{ width: '100%', height: `${isLandingPage ? iframeHeight : (iframeHeight - 20)}px`, border: 'none', display: 'block' }}
      />
    </React.Fragment>
  );
}

